<ui-modal-icon-title icon="info-circle" iconStyle="light" title="Warenverfügbarkeit"></ui-modal-icon-title>

<mat-dialog-content>
  <p>Die Verfügbarkeitsprüfung von Artikeln erfolgt <strong>bereits während des Einkaufs</strong> im Hintergrund.</p>

  <p>Zusätzlich wird die Bestellung nach Eingang geprüft. Das Ergebnis ist <strong>wenige Minuten nach der Übertragung</strong> der Bestellung einsehbar.</p>
</mat-dialog-content>

<mat-dialog-actions>
  <ui-button mat-dialog-close buttonStyle="text">Schließen</ui-button>
</mat-dialog-actions>
